/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WarehouseShipToAddressDTO interface.
 */
export function instanceOfWarehouseShipToAddressDTO(value) {
    return true;
}
export function WarehouseShipToAddressDTOFromJSON(json) {
    return WarehouseShipToAddressDTOFromJSONTyped(json, false);
}
export function WarehouseShipToAddressDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'line1': json['line1'] == null ? undefined : json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'country': json['country'] == null ? undefined : json['country'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}
export function WarehouseShipToAddressDTOToJSON(json) {
    return WarehouseShipToAddressDTOToJSONTyped(json, false);
}
export function WarehouseShipToAddressDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'fullName': value['fullName'],
        'line1': value['line1'],
        'line2': value['line2'],
        'city': value['city'],
        'state': value['state'],
        'postalCode': value['postalCode'],
        'country': value['country'],
        'phone': value['phone'],
    };
}
